<template>
  <div>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container fluid>
      <div class="mb-3" v-if="isItSupport">
        <label>My Request</label>
        <v-data-table
          :headers="headers"
          :items="myRequest"
          style="border: solid 1px"
          :loading="loading"
          disable-pagination
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.community }}</td>
              <td>{{ props.item.requestedBy && props.item.requestedBy.displayName }}</td>
              <td>{{ props.item.timeRequested / 60 }} minutes</td>
              <td>{{ props.item.accessType === 'readonly' ? 'Read only' : 'Read / Write' }}</td>
              <td>{{ props.item.accessToLiveCommunityConfiguration ? 'Yes' : 'No' }}</td>
              <td>{{ props.item.accessToITSupportCollection ? 'Yes' : 'No' }}</td>
              <td>{{ $filters.DateTimeFilter(props.item.insertedByDate) }} (UTC)</td>
              <td>
                <div v-if="props.item.decision">
                  {{ props.item.decision === 'approved' ? 'Approved' : 'Rejected' }}
                  <div v-if="props.item.decision === 'approved'">{{ $filters.DateTimeFilter(pprops.item.approvedDate) }} (UTC)</div>
                </div>
                <div v-else>In process...</div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div v-if="isProcessManager">
        <label>Requests</label>
        <v-data-table :headers="headers" :items="items" style="border: solid 1px" :loading="loading">
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.community }}</td>
              <td>{{ props.item.requestedBy && props.item.requestedBy.displayName }}</td>
              <td>{{ props.item.timeRequested / 60 }} minutes</td>
              <td>{{ props.item.accessType === 'readonly' ? 'Read only' : 'Read / Write' }}</td>
              <td>{{ props.item.accessToLiveCommunityConfiguration ? 'Yes' : 'No' }}</td>
              <td>{{ props.item.accessToITSupportCollection ? 'Yes' : 'No' }}</td>
              <td>{{ $filters.DateTimeFilter(props.item.insertedByDate) }} (UTC)</td>
              <td>
                <div
                  v-if="
                    isProcessManager &&
                    !props.item.decision &&
                    props.item.requestedBy &&
                    props.item.requestedBy.id != currentUser.id
                  "
                >
                  <v-btn small color="success" @click="setDecision(props.item.username, 'approved', props.item.community)"
                    >Approve</v-btn
                  >
                  <v-btn
                    small
                    color="error"
                    class="ml-2"
                    @click="setDecision(props.item.username, 'rejected', props.item.community)"
                    >Reject</v-btn
                  >
                </div>
                <div v-if="props.item.decision">
                  {{ props.item.decision === 'approved' ? 'Approved' : 'Rejected' }}
                  <div v-if="props.item.decision === 'approved'">{{ $filters.DateTimeFilter(props.item.approvedDate) }} (UTC)</div>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import AdminService from '@/services/admin.service'
import Toaster from '@/components/Toaster'

export default {
  name: 'DbAccessTable',
  components: {
    Toaster
  },
  data() {
    return {
      items: [],
      myRequest: [],
      loading: false,
      headers: [
        {
          title: 'Community',
          key: 'community'
        },
        {
          title: 'Requested By',
          key: 'requestedBy.displayName'
        },
        {
          title: 'Time Requested',
          key: 'timeRequested'
        },
        {
          title: 'Access Type',
          key: 'accessType'
        },
        {
          title: 'Access to all communities config?',
          key: 'accessToLiveCommunityConfiguration'
        },
        {
          title: 'Access to IT Support data?',
          key: 'accessToITSupportCollection'
        },
        {
          title: 'Requested on',
          key: 'insertedByDate'
        },
        {
          title: '',
          width: '250px'
        }
      ],
      loadingDialog: false
    }
  },
  methods: {
    getList() {
      this.loading = true
      if (this.isItSupport) {
        AdminService.getMyDbAccessControl()
          .then((response) => {
            if (response) {
              this.myRequest = [response]
            } else {
              this.myRequest = []
            }
          })
          .finally(() => (this.loading = false))
      }

      if (this.isProcessManager) {
        AdminService.getDbAccessControlPendingApproval()
          .then((response) => {
            this.items = response
          })
          .finally(() => (this.loading = false))
      }
    },
    setDecision(username, decision, communityAbbreviation) {
      if (this.loadingDialog) return
      this.loadingDialog = true
      AdminService.setDecisionOnDbAccessRequest(username, decision, communityAbbreviation)
        .catch(() => {
          this.$refs.toaster.pop('error', `An error has ocurred`)
        })
        .finally(() => {
          this.loadingDialog = false
          this.getList()
        })
    }
  },
  computed: {
    isItSupport() {
      const adminRoles = this.$store.state.currentUserAdminRoles.adminRoles
      return adminRoles.findIndex((i) => i.toLowerCase() === 'itsupport') > -1
    },
    isProcessManager() {
      const adminRoles = this.$store.state.currentUserAdminRoles.adminRoles
      return adminRoles.findIndex((i) => i.toLowerCase() === 'processmanager') > -1
    },
    currentUser() {
      return this.$store.state.currentUser.user
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style></style>
